import { buildProps as t, definePropType as e } from "./index601.js";
import { datePickTypes as a } from "./index695.js";
const r = [
  "date",
  "dates",
  "year",
  "years",
  "month",
  "months",
  "week",
  "range"
], d = t({
  cellClassName: {
    type: e(Function)
  },
  disabledDate: {
    type: e(Function)
  },
  date: {
    type: e(Object),
    required: !0
  },
  minDate: {
    type: e(Object)
  },
  maxDate: {
    type: e(Object)
  },
  parsedValue: {
    type: e([Object, Array])
  },
  rangeState: {
    type: e(Object),
    default: () => ({
      endDate: null,
      selecting: !1
    })
  },
  disabled: Boolean
}), s = t({
  type: {
    type: e(String),
    required: !0,
    values: a
  },
  dateFormat: String,
  timeFormat: String,
  showNow: {
    type: Boolean,
    default: !0
  },
  showConfirm: Boolean,
  showFooter: {
    type: Boolean,
    default: !0
  },
  showWeekNumber: Boolean,
  border: Boolean,
  disabled: Boolean,
  editable: {
    type: Boolean,
    default: !0
  }
}), i = t({
  unlinkPanels: Boolean,
  visible: {
    type: Boolean,
    default: !0
  },
  showConfirm: Boolean,
  showFooter: {
    type: Boolean,
    default: !0
  },
  border: Boolean,
  disabled: Boolean,
  parsedValue: {
    type: e(Array)
  }
}), p = (o) => ({
  type: String,
  values: r,
  default: o
});
export {
  d as datePickerSharedProps,
  i as panelRangeSharedProps,
  s as panelSharedProps,
  p as selectionModeWithDefault
};
